import React, { memo, useEffect, useRef} from "react";
import BundlesSoldBarGraph from "./graphs/bundlesSoldBarGraph";
import TopBundlesMonth from "./graphs/topBundlesMonth";
import OrdersPerDayGraph from "./graphs/ordersPerDayGraph";
import ActiveSubscription from "./graphs/activeSubscription";
import * as PR from "../../prime-modules/index";

const GraphsBlock = (props) => {
  const appName = process.env?.REACT_APP_NAME;
  const graphContainerRef = useRef(null);
  const graphList = props ? props.selectedGraphs : [];
  const monthGraph = props ? props.selectedMonthGraph : [];
  const orderGraph = props ? props.selectedOrderGraphs : [];
  const revenueGraph = props ? props.selectedRevenueGraphs : [];
  const activeSubscription = props ? props.activeSubscriptions : []
  const selectedGraphValues = props ? props.selectedGraphValues : []
  const loadingGraphs = props ? props.loadingGraphs : {}

  useEffect(() => {
    if (graphContainerRef.current) {
      graphContainerRef.current.scrollTop = graphContainerRef.current.scrollHeight;
    }
  }, [props?.selectedGraphs]);

  return (
    <>
      <div className="grid mt-4 m-grid">

      {/* Bundles Sold Section */}
        {selectedGraphValues?.includes("bundlesSold") && (
           <div className={`col-12 ${selectedGraphValues?.includes("activeSubscription") || [2, 3, 4, 6].includes(selectedGraphValues.length) ? "md:col-6" : "md:col-12"}`}>
            <div className="card right-section">
              <div className="p-3 border-50 border-round graph-block-bg" ref={graphContainerRef}> 
                <div className="sticky-header">
                  <div className="flex align-items-center justify-content-between block-header">
                    <h2>Country Wise Bundles Sold</h2>
                  </div>
                </div>
                <div className="flex align-items-center block-main mt-4">
                  <div className="card w-12">
                    {loadingGraphs?.bundlesSold ? (
                      <div style={{ height: "250px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <PR.ProgressSpinner />
                      </div>
                    ) : (
                    graphList.id === "bundlesSold" && (
                      <BundlesSoldBarGraph
                        graph={graphList}
                        data={graphList?.values}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Popular Bundles Sold This Month Section */}
        {selectedGraphValues?.includes("popularBundles") && (
        <div className={`col-12 ${selectedGraphValues?.includes("activeSubscription") || [2, 3, 4, 6].includes(selectedGraphValues.length) ? "md:col-6" : "md:col-12"}`}>
          <TopBundlesMonth monthGraph={monthGraph} loadingGraphs={loadingGraphs} />
        </div>
        )}
        
        {/* Orders & Revenue Per Day Section */}
        {selectedGraphValues?.includes("ordersRevenuePerDay") && (
       <div className={`col-12 ${selectedGraphValues?.includes("activeSubscription") || [2, 4, 6].includes(selectedGraphValues.length) ? "md:col-6" : "md:col-12 graph-custom-height"}`}>
            <div className="card right-section">
              <div className="p-3 border-50 border-round graph-block-bg" ref={graphContainerRef}>
                <div className="sticky-header">
                  <div className="flex align-items-center justify-content-between block-header">
                    <h2>Orders & Revenue</h2>
                  </div>
                </div>
                <div className="mt-4">
                  {loadingGraphs?.orderRevenueGraph ? (
                    <div style={{ height: "250px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <PR.ProgressSpinner />
                    </div>
                  ) : (
                  <OrdersPerDayGraph
                    orderGraph={orderGraph?.values}
                    revenueGraph={revenueGraph?.values}
                  />
                  )}
                </div>
              </div>
            </div>
        </div>
        )}

        {/* Active Subscription Section */}
        {(selectedGraphValues?.includes("activeSubscription") && appName === "data2go-iot") && (
        <div className={`col-12 ${!selectedGraphValues?.includes("activeSubscription") || [2, 4, 6].includes(selectedGraphValues.length) ? "md:col-6" : "md:col-12"}`}>
          <div className="card right-section">
             <div className="p-3 border-50 border-round graph-block-bg" ref={graphContainerRef}>
              <div className="sticky-header">
                <div className="flex align-items-center justify-content-between block-header">
                  <h2>Total number of active subscriptions</h2>
                </div>
              </div>
              {loadingGraphs?.activeGraph ? (
                <div style={{ height: "250px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <PR.ProgressSpinner />
                </div>
              ) : (
              <ActiveSubscription activeSubscription={activeSubscription} />
              )}
            </div>
          </div>
        </div>
        )}

      </div>
    </>
  );
};

export default memo(GraphsBlock);